import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-star-fill",
  templateUrl: "./med-icon-star-fill.component.html",
})
export class MedIconStarFillComponent extends SvgMixinComponent {}
